import React from 'react';
import { FadeIn, Section, Button } from '../ui/Shared';
export const BonusesSection = () => {
  const bonuses = [{
    num: '1',
    title: 'Depresión Postparto y Lactancia',
    desc: 'Entendé la conexión entre la lactancia y tu estado emocional. Herramientas específicas para mamás que amamantan y atraviesan el postparto.'
  }, {
    num: '2',
    title: 'Cómo Volver a Sentirte Mujer, No Solo Madre',
    desc: 'Tu identidad no terminó el día que nació tu bebé. Esta guía te ayuda a reconectar con la mujer que sos — más allá de la maternidad.'
  }, {
    num: '3',
    title: 'Plan Preventivo para Futuro Embarazo',
    desc: 'Herramientas y estrategias para que, si decidís volver a ser mamá, estés emocionalmente preparada y sostenida desde el principio.'
  }, {
    num: '4',
    title: 'Recuperando el Sueño Emocional',
    desc: 'Un programa específico para reducir la ansiedad nocturna, calmar la mente y volver a descansar de verdad.'
  }];
  return <Section className="bg-gradient-to-b from-white to-pink-light/50" data-id="element-50">
      <FadeIn className="text-center mb-10" data-id="element-51">
        <h2 className="text-4xl md:text-5xl mb-3" data-id="element-52">
          🎁 Y además... 4 Bonos Exclusivos de Regalo
        </h2>
        <p className="text-xl italic text-brown-text/80" data-id="element-53">
          Incluidos con tu compra hoy — sin costo adicional
        </p>
      </FadeIn>

      <div className="max-w-4xl mx-auto space-y-5" data-id="element-54">
        {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-55">
            <div className="bg-white p-5 md:p-6 rounded-2xl border border-pink-border shadow-sm flex flex-col md:flex-row gap-5 items-start md:items-center" data-id="element-56">
              <div className="w-14 h-14 shrink-0 bg-pink-light rounded-full flex items-center justify-center text-2xl font-bold text-pink-deep font-heading border border-pink-border" data-id="element-57">
                {bonus.num}
              </div>
              <div className="flex-grow" data-id="element-58">
                <h3 className="text-xl font-bold text-pink-deep mb-2 font-heading" data-id="element-59">
                  ✦ BONUS {bonus.num}: {bonus.title}
                </h3>
                <p className="text-brown-text/80 italic mb-3" data-id="element-60">{bonus.desc}</p>
                <span className="inline-block bg-pink-primary/10 text-pink-deep text-sm font-bold px-3 py-1 rounded-full border border-pink-primary/20" data-id="element-61">
                  🎁 GRATIS CON TU COMPRA
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.5} className="text-center mt-8" data-id="element-62">
        <p className="italic text-brown-text/70" data-id="element-63">
          Todo incluido. Sin costos ocultos. Sin suscripciones. Tuyo para
          siempre.
        </p>
      </FadeIn>
    </Section>;
};
export const ValueStack = () => <Section className="bg-celeste-light" data-id="element-64">
    <FadeIn data-id="element-65">
      <h2 className="text-4xl md:text-5xl text-center mb-12 italic" data-id="element-66">
        Todo lo que recibís hoy
      </h2>

      <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-lg border border-celeste-primary/20 overflow-hidden" data-id="element-67">
        <div className="p-6 md:p-8" data-id="element-68">
          <div className="space-y-4" data-id="element-69">
            {[{
            icon: '📗',
            name: 'Tomo II — "Sanación Profunda"',
            val: '$24.950',
            status: 'Incluido'
          }, {
            icon: '🎁',
            name: 'Bonus 1 — Depresión Postparto y Lactancia',
            val: '$9.990',
            status: 'Gratis'
          }, {
            icon: '🎁',
            name: 'Bonus 2 — Volver a Sentirte Mujer',
            val: '$9.990',
            status: 'Gratis'
          }, {
            icon: '🎁',
            name: 'Bonus 3 — Plan Preventivo Futuro Embarazo',
            val: '$9.990',
            status: 'Gratis'
          }, {
            icon: '🎁',
            name: 'Bonus 4 — Recuperando el Sueño Emocional',
            val: '$9.990',
            status: 'Gratis'
          }, {
            icon: '📩',
            name: 'Entrega inmediata a tu correo',
            val: '—',
            status: 'Incluido'
          }, {
            icon: '♾️',
            name: 'Acceso de por vida al material',
            val: '—',
            status: 'Incluido'
          }].map((item, i) => <div key={i} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0" data-id="element-70">
                <div className="flex items-center gap-3" data-id="element-71">
                  <span className="text-xl" data-id="element-72">{item.icon}</span>
                  <span className="font-medium text-sm md:text-base" data-id="element-73">
                    {item.name}
                  </span>
                </div>
                <div className="flex items-center gap-4 text-sm" data-id="element-74">
                  <span className="text-gray-400 line-through hidden md:inline" data-id="element-75">
                    {item.val}
                  </span>
                  <span className="text-green-600 font-bold bg-green-50 px-2 py-1 rounded" data-id="element-76">
                    ✅ {item.status}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="bg-pink-light p-6 md:p-8 border-t border-pink-border flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-77">
          <div className="text-center md:text-left" data-id="element-78">
            <p className="text-gray-500 line-through mb-1" data-id="element-79">
              Valor total real: $89.860
            </p>
            <p className="text-2xl font-bold text-pink-deep font-heading" data-id="element-80">
              🌸 Tu inversión hoy
            </p>
          </div>
          <div className="text-center md:text-right" data-id="element-81">
            <p className="text-4xl font-bold text-pink-deep" data-id="element-82">$19.999 ARS</p>
            <p className="text-sm font-bold text-pink-primary mt-1 animate-pulse" data-id="element-83">
              ¡OFERTA ACTIVA!
            </p>
          </div>
        </div>
      </div>
    </FadeIn>
  </Section>;
export const PricingCTA = () => <Section id="comprar" className="bg-white" data-id="element-84">
    <FadeIn className="max-w-3xl mx-auto" data-id="element-85">
      <div className="bg-white rounded-[2.5rem] shadow-2xl border border-pink-border p-6 md:p-10 text-center relative overflow-hidden" data-id="element-86">
        {/* Decorative background blur */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-gradient-to-b from-pink-light to-transparent opacity-50" data-id="element-87"></div>

        <div className="relative z-10" data-id="element-88">
          <h2 className="text-4xl md:text-5xl font-bold text-pink-deep mb-3 font-heading" data-id="element-89">
            🌸 Tu momento de renacer
          </h2>
          <p className="text-xl italic text-brown-text/80 mb-6" data-id="element-90">
            Solo por tiempo limitado
          </p>

          <div className="mb-6" data-id="element-91">
            <p className="text-gray-400 line-through text-xl mb-2" data-id="element-92">
              Antes: $49.900 ARS
            </p>
            <p className="text-6xl md:text-7xl font-bold text-pink-deep mb-3" data-id="element-93">
              $19.999 ARS
            </p>
            <p className="text-sm font-medium text-brown-text/70 bg-gray-50 inline-block px-4 py-2 rounded-full" data-id="element-94">
              Pago único · Sin suscripción · Acceso inmediato
            </p>
          </div>

          <Button className="w-full md:w-auto text-xl py-6 px-12 mb-6 shadow-pink-primary/30" data-id="element-95">
            〔 🌸 SÍ, QUIERO EMPEZAR MI RENACER 〕
          </Button>

          <div className="space-y-2 text-left max-w-md mx-auto mb-6 bg-pink-light/30 p-5 rounded-2xl" data-id="element-96">
            <p className="flex items-center gap-2 font-medium" data-id="element-97">
              <span className="text-green-500" data-id="element-98">✓</span> Recibís todo en tu
              correo en minutos
            </p>
            <p className="flex items-center gap-2 font-medium" data-id="element-99">
              <span className="text-green-500" data-id="element-100">✓</span> Acceso de por vida a los
              2 tomos + 4 bonos
            </p>
            <p className="flex items-center gap-2 font-medium" data-id="element-101">
              <span className="text-green-500" data-id="element-102">✓</span> 7 días de garantía — sin
              preguntas
            </p>
          </div>

          <p className="text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-103">
            <span data-id="element-104">🔒</span> Compra 100% segura · Pago protegido
          </p>
        </div>
      </div>
    </FadeIn>
  </Section>;